module.exports = __webpack_public_path__ + "static/media/like.04e77300.svg";